import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/solution/automotive-updated/why-choose.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose TekRevol as Your
              <span>Automotive App Development</span> Company?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Partner with us for industry-specific expertise and measurable
              outcomes. Our solutions focus on optimizing business operations,
              driving growth, and enhancing performance for automotive
              enterprises.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Custom-Built for Automotive</h5>
                    <p>
                      Tailored apps to streamline fleet management and optimize
                      operations.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>Expertise that Drives Results</h5>
                    <p>
                      Proven experience in delivering high-performance,
                      feature-rich automotive apps.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>Scalable for Future Growth</h5>
                    <p>
                      Our solutions scale with your business and adapt to new
                      technologies.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Rapid Development, Faster Launch</h5>
                    <p>
                      Agile processes ensure quicker time to market, giving you
                      a competitive edge.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-md-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>Boost Customer Engagement</h5>
                    <p>
                      Create intuitive, user-friendly apps that enhance customer
                      loyalty.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>Drive Business Growth</h5>
                    <p>
                      Increase revenue, cut costs, and improve ROI with
                      optimized automotive solutions.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
